import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { AppLayout } from "@/components/intel/Layout";
import { ModuleShell } from "@/components/intel/ModuleShell";
import { listScanRuns } from "@/lib/intel/feeds.functions";
import { Network, ArrowRight } from "lucide-react";

export const Route = createFileRoute("/graph")({
  head: () => ({ meta: [{ title: "Relationship Graphs · CARIO INTEL" }] }),
  component: () => <AppLayout><GraphIndex /></AppLayout>,
});

function GraphIndex() {
  const list = useServerFn(listScanRuns);
  const q = useQuery({ queryKey: ["scan-runs-for-graph"], queryFn: () => list() });
  return (
    <ModuleShell
      eyebrow="Relationship Graphs"
      title="Choose a scan to explore"
      description="Each scan has its own persistent, editable entity graph with an AI graph assistant. Pick a case to open its graph."
    >
      {q.isLoading && <div className="glass rounded-xl p-6 text-sm text-muted-foreground">Loading scans…</div>}
      {!q.isLoading && !q.data?.length && (
        <div className="glass rounded-xl p-6 text-sm text-muted-foreground">
          No scans yet. Run an investigation from the <Link to="/dashboard" className="text-cyan underline">dashboard</Link> to build your first graph.
        </div>
      )}
      <div className="grid gap-2 md:grid-cols-2 lg:grid-cols-3">
        {q.data?.map((r) => (
          <Link key={r.id} to="/vault/$scanId/graph" params={{ scanId: r.id }}
            className="glass rounded-xl p-4 hover:border-cyan/40 transition-colors group">
            <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-cyan">
              <Network className="h-3 w-3" /> {r.targetType}
            </div>
            <div className="mt-2 font-display text-base truncate">{r.target}</div>
            <div className="mt-1 font-mono text-[10px] text-muted-foreground">
              {r.status} · risk {r.riskScore}/100 · {new Date(r.createdAt).toLocaleDateString()}
            </div>
            <div className="mt-3 flex items-center gap-1 text-xs text-cyan opacity-60 group-hover:opacity-100">
              Open graph <ArrowRight className="h-3 w-3" />
            </div>
          </Link>
        ))}
      </div>
    </ModuleShell>
  );
}